import * as React from 'react'

export function CustomersPage(props) {
  return (
    <div>
      <h1>Customers</h1>
    </div>
  )
}
